import { Pipe, PipeTransform } from '@angular/core';
import { translateIncidentCreatedBy } from '../mappers/enum-translation-mapper';

@Pipe({
  name: 'translateIncidentCreatedByEnum',
})
export class TranslateIncidentCreatedByEnumPipe implements PipeTransform {
  transform(value: any): any {
    return translateIncidentCreatedBy(value);
  }
}
